import i18next from 'i18next';

// waiting for more Types to be added from API
function getTitleByType(type: string) {
	switch (type) {
	case 'BN_CALL_LOG':
		return i18next.t('BN Call');
	case 'email':
		return i18next.t('Email');
	case 'sms':
		return i18next.t('SMS');
	case 'rator':
		return i18next.t('Rator');
	case 'ERATE_SYSTEM_SMS':
		return i18next.t('ERATE System SMS');
	case 'ERATE_CALL_LOG':
		return i18next.t('ERATE System Call');
	case 'THREESIXTY_NEW_CUSTOMER_RESP':
		return i18next.t('360 - New customer responsible');
	case 'THREESIXTY_COMMENT':
		return i18next.t('360 - Comment');
	case 'THREESIXTY_NEW_SAF_VALUE':
		return i18next.t('360 - New SAF value');
	case 'THREESIXTY_OUTGOING_SMS':
		return i18next.t('360 - Outgoing SMS');
	case 'THREESIXTY_OUTGOING_TRUSTPILOT':
		return i18next.t('360 - Trustpilot');
	case 'THREESIXTY_INCIDENT_LOG':
		return i18next.t('360 - Incident log');
	case 'VISMA_INVOICE':
		return i18next.t('Visma Invoice');
	case 'ZENDESK_UPSELL':
		return i18next.t('Zendesk - upsell');
	default:
		return i18next.t('Unknown event');
	}
}

export default getTitleByType;
